/**
 * Epics for post categoires
 */
import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { adminService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as categoryActions from "./actions";

export function fetchCategories(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_CATEGORIES),
    mergeMap(({ payload }) => {
      return adminService.getCategoires(payload).pipe(
        map((res) =>
          categoryActions.fetchCategoriesSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
